import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Automation from './pages/Automation';
import Software from './pages/Software';
import Products from './pages/products/Products';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Cctv from './pages/Cctv';
import TruckScales from './pages/products/TruckScales';
import CountingScales from './pages/products/CountingScales';
import BeltScales from './pages/products/BeltScales';
import BenchScales from './pages/products/BenchScales';
import FloorScales from './pages/products/FloorScales';
import MonorailScales from './pages/products/MonorailScales';
import ForkliftScales from './pages/products/ForkliftScales';
import RailwayScales from './pages/products/RailwayScales';
import CheckweighingScales from './pages/products/CheckweighingScales';
import LoadCells from './pages/products/LoadCells';
import Dynamometers from './pages/products/Dynamometers';
import AgriculturalEquipment from './pages/products/AgriculturalEquipment';
import ForceEquipment from './pages/products/ForceEquipment';
import Printers from './pages/products/Printers';
import WeightIndicators from './pages/products/WeightIndicators';
import ReviewProduct from './pages/products/ReviewProduct';
import Admin from './pages/admin/Admin';
import AdminHome from './pages/admin/AdminHome';
import PriceList from './pages/admin/PriceList';
import Permissions from './pages/admin/Permissions';
import Diagnostico from './pages/admin/Diagnostico';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './api/auth/AuthContext';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './api/telemetry/appInsights';
import './App.css';

function App() {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
    <AuthProvider>
    <Router>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/empleado" element={<Home />} />
            <Route path="/quienes-somos" element={<About />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/automatizacion" element={<Automation />} />
            <Route path="/software" element={<Software />} />
            <Route path="/productos" element={<Products />} />
            <Route path="/productos/basculas-camioneras" element={<TruckScales />} />
            <Route path="/productos/basculas-contadoras" element={<CountingScales />} />
            <Route path="/productos/basculas-de-banda" element={<BeltScales />} />
            <Route path="/productos/basculas-de-banco" element={<BenchScales />} />
            <Route path="/productos/basculas-de-piso" element={<FloorScales />} />
            <Route path="/productos/basculas-de-monorriel" element={<MonorailScales />} />
            <Route path="/productos/basculas-de-montacargas" element={<ForkliftScales />} />
            <Route path="/productos/basculas-para-ferrocarril" element={<RailwayScales />} />
            <Route path="/productos/basculas-verificadoras" element={<CheckweighingScales />} />
            <Route path="/productos/celdas-de-carga" element={<LoadCells />} />
            <Route path="/productos/dinamometros" element={<Dynamometers />} />
            <Route path="/productos/equipos-agropecuarios" element={<AgriculturalEquipment />} />
            <Route path="/productos/equipo-de-fuerza" element={<ForceEquipment />} />
            <Route path="/productos/impresoras" element={<Printers />} />
            <Route path="/productos/indicadores-de-peso" element={<WeightIndicators />} />
            <Route path="/productos/revisar/:productId" element={<ReviewProduct />} />
            <Route path="/productos/nuevo/:category" element={<ReviewProduct />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<Admin />}>
                <Route index element={<AdminHome />} />
                <Route path="lista-de-precios" element={<PriceList />} />
                <Route path="permisos" element={<Permissions />} />
                <Route path="diagnostico" element={<Diagnostico />} />
              </Route>
            </Route>
            <Route path="/clientes" element={<Clients />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/cctv" element={<Cctv />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </AuthProvider>
    </AppInsightsContext.Provider>
  );
}

export default App;
